export default __webpack_public_path__ + "static/media/6112a52ec09068eeedc2b9bbd1553d65.svg";